const normalizeCashSessionRole = (value) => {
  const normalized = String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (["caissier", "caissiere"].includes(normalized)) return "cashier";
  return normalized;
};

export const canUseCashSessionForRole = (value) =>
  new Set(["cashier", "caisse", "manager", "admin"]).has(
    normalizeCashSessionRole(value),
  );

export { normalizeCashSessionRole };
